'use client';

import { c as _c } from "react/compiler-runtime";
import clsx from 'clsx';
import Link from 'next/link';
import { FC, RefObject } from 'react';
import ArrowNext from '@/components/shared/Icon/ArrowNext';
import { Typography } from '@/components/shared/Typography';
import StrapiRichContent from '@/components/StrapiRichContent';
import css from '../style.module.scss';
import { CasesScrollItemDto, CasesSliderResolvedLayout } from '../types';
interface Props {
  cases: CasesScrollItemDto[];
  activeIndex: number;
  rightItemsRef: RefObject<(HTMLDivElement | null)[]>;
  layout: CasesSliderResolvedLayout;
}
const CasesSliderRightPanel: FC<Props> = t0 => {
  const $ = _c(14);
  const {
    cases,
    activeIndex,
    rightItemsRef,
    layout
  } = t0;
  if (!layout.rightSideTitle && !layout.rightSideText && !layout.rightSideLink) {
    return null;
  }
  const titleOnly = layout.rightSideTitle && !layout.rightSideText && !layout.rightSideLink;
  const t1 = titleOnly && css.rightTitleOnly;
  let t2;
  if ($[0] !== t1) {
    t2 = clsx(css.right, t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== activeIndex || $[3] !== cases || $[4] !== layout.rightSideLink || $[5] !== layout.rightSideText || $[6] !== layout.rightSideTitle || $[7] !== rightItemsRef) {
    t3 = cases.map((slide, i) => <div key={`${slide.slideTitle}-${i}`} ref={el => {
      rightItemsRef.current[i] = el;
    }} className={css.rightBlock} aria-hidden={i !== activeIndex}>{layout.rightSideTitle ? <Typography className={css.rightTitle} variant="h6" tag="h3">{slide.slideTitle}</Typography> : null}{layout.rightSideText ? <div className={css.rightDescription}><Typography className={css.rightDescription} variant="body-m" tag="div">{typeof slide.slideDescription === "string" ? slide.slideDescription : slide.slideDescription ? <StrapiRichContent content={slide.slideDescription} /> : null}</Typography></div> : null}{layout.rightSideLink && slide.cta?.url ? <Link type="link" href={slide.cta.url} className={clsx(css.caseLink, css.caseLinkDesktop)}><Typography variant="body-m" tag="span">{slide.cta.text || "See Case study"}</Typography>{" "}<ArrowNext size={18} /></Link> : null}</div>);
    $[2] = activeIndex;
    $[3] = cases;
    $[4] = layout.rightSideLink;
    $[5] = layout.rightSideText;
    $[6] = layout.rightSideTitle;
    $[7] = rightItemsRef;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t3) {
    t4 = <div className={css.rightStack}>{t3}</div>;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t2 || $[12] !== t4) {
    t5 = <aside className={t2}>{t4}</aside>;
    $[11] = t2;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
};
export default CasesSliderRightPanel;